import Chip from '@components/Chip';
import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import { useAtom } from 'jotai';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import { amountAtom } from '../../../_shared/atoms/prepaidCardAtoms';
import { nameAtom } from '../../atoms/purchasePrepaidCardAtoms';

const AVAILABLE_AMOUNTS = [1, 2, 3, 5];

function CardInfo() {
    const { t } = useTranslation('prepaidCard');
    const [amount, setAmount] = useAtom(amountAtom);
    const [name, setName] = useAtom(nameAtom);
    const [isManual, setIsManual] = useState(false);
    return (
        <Column className={styles.container}
            fullWidth
            as='section'
            spacing={12}>
            <Text size='2xl' fontWeight='bold' color={colors.gray7}
                className={styles.title} >
                {t('image.cardNickname')}
            </Text>
            <Text size='lg' fontWeight='bold' color={colors.gray7}>
                {t('image.enterNickname')}
            </Text>
            <TextField value={name}
                onChange={(e) => setName(e.target.value)} />
            <Text size='s' fontWeight='bold' color={colors.gray5}>
                {t('image.nicknameInfo')}
            </Text>
            <Text size='2xl' fontWeight='bold' color={colors.gray7}
                className={styles.title} >
                {t('image.purchaseAmount')}
            </Text>
            <Chip.Container>
                {AVAILABLE_AMOUNTS.map((availableAmount) => (
                    <Chip isSelected={availableAmount * 10000 === amount && !isManual}
                        key={`amount-${availableAmount}`}
                        onClick={() => {
                            setAmount(availableAmount * 10000);
                            setIsManual(false);
                        }} >
                        {availableAmount}{t('components.amount.tenThousandUnit')}
                    </Chip>
                ))}
                <Chip isSelected={isManual}
                    onClick={() => setIsManual(true)} >
                    {t('image.freeInput')}
                </Chip>
            </Chip.Container>
            {isManual && (
                <TextField placeholder={t('image.amountPlaceholder')}
                    // @ts-ignore
                    type='number'
                    className={styles.manual}
                    step={1000}
                    min={10000}
                    value={amount.toString()}
                    setValue={(v) => setAmount(Math.min(Number(v), 500000))}
                    inputMode='numeric' />
            )}
        </Column>
    );
}

export default CardInfo;
